import React, { useState, useEffect } from 'react';
import useFontFamilies from '../../hooks/useFontFamilies';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import { MuiColorInput } from 'mui-color-input';
import ButtonMain from '../backend/buttonApp/Button';
import UseToast from '../UseToast';
import {
  Box,
  Typography,
} from '@mui/material';
import Swal from 'sweetalert2';

const GlobalWayfinderButtonSettings = ({ userId, buttonColor }) => {
  const fontOptions = useFontFamilies('option');
  console.log('GlobalWayfinderButtonSettings rendered with userId:', userId);

  const { showMsgSuccessToast, showErrorToast } = UseToast();
  const [loading, setLoading] = useState(false);
  const [clickSoundFile, setClickSoundFile] = useState(null);
  const [keyboardClickSoundFile, setKeyboardClickSoundFile] = useState(null);
  const [pngFile, setPngFile] = useState(null);
  const [iconFile, setIconFile] = useState(null);
  const [uploadingStates, setUploadingStates] = useState({
    clickSound: false,
    keyboardClickSound: false,
    pngBtn: false,
    buttonIcon: false,
  });

  const [settings, setSettings] = useState({
    cornerRadius: 5,
    height: 50,
    width: 150,
    outlineColor: '#000000',
    outlineThickness: 1,
    fillColor: '#ffffff',
    font: 'Arial',
    fontColor: '#000000',
    fontSize: 16,
    shadow: {
      angle: 125,
      size: 10,
      distance: 15,
      alpha: 0.2,
      color: '#000000',
    },
    highlight: {
      borderColor: '#8f8f8f',
      fillColor: '#000000',
      fontColor: '#ffffff',
    },
    clickSound: '',
    clickSoundFilename: '',
    clickSoundVolume: 1,
    keyboardClickSound: '',
    keyboardClickSoundFilename: '',
    keyboardClickSoundVolume: 1,
    textAlign: 'center',
    marginBottom: 5,
    lineHeight: 1,
    padding: 10,
    pngBtnenabled: false,
    hideBtnText: false,
    btnPng: '',
    btnPngFileName: '',
    enableIcon: false,
    buttonIcon: '',
    buttonIconFileName: '',
    iconPosition: 'top',
    iconSize: 90,
    iconSpacing: 8,
  });

  useEffect(() => {
    if (userId) {
      fetchSettings();
    }
  }, [userId]);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/wayfinder/global-wayfinder-button-settings/${userId}`);
      if (response.data.success) {
        const flatSettings = response.data.data.globalSettings;

        console.log('global wayifner button settinghs', flatSettings)

        setSettings(prevSettings => ({
          ...prevSettings,
          ...flatSettings,
        }));
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      showErrorToast('Failed to load settings');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    // Handle nested objects
    if (key.includes('.')) {
      const keys = key.split('.');
      setSettings(prevSettings => {
        const newSettings = { ...prevSettings };
        let current = newSettings;
        for (let i = 0; i < keys.length - 1; i++) {
          current[keys[i]] = { ...current[keys[i]] };
          current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = value;
        return newSettings;
      });
    } else {
      setSettings(prevSettings => ({
        ...prevSettings,
        [key]: value,
      }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        `/api/wayfinder/global-wayfinder-button-settings/${userId}`,
        {
          globalSettings: settings,
        }
      );

      if (response.data.success) {
        showMsgSuccessToast('Global button settings saved successfully!');
      } else {
        showErrorToast('Failed to save settings');
      }
    } catch (error) {
      console.error('Error saving settings:', error);
      showErrorToast('Failed to save settings');
    } finally {
      setLoading(false);
    }
  };

  const handleUploadClickSound = async () => {
    if (!clickSoundFile) {
      showErrorToast('Please select a file first!');
      return;
    }

    setUploadingStates(prev => ({ ...prev, clickSound: true }));

    try {
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: clickSoundFile.name,
          fileType: clickSoundFile.type,
        },
      });

      const { url } = response.data;

      await axios.put(url, clickSoundFile, {
        headers: {
          'Content-Type': clickSoundFile.type,
        },
      });

      const fileUrl = url.split('?')[0];

      setSettings(prevSettings => ({
        ...prevSettings,
        clickSound: fileUrl,
        clickSoundFilename: clickSoundFile.name,
      }));

      showMsgSuccessToast('Click sound uploaded successfully!');
      setClickSoundFile(null);
    } catch (error) {
      console.error('Upload failed:', error);
      showErrorToast('Upload failed. Please try again.');
    } finally {
      setUploadingStates(prev => ({ ...prev, clickSound: false }));
    }
  };

  const handleUploadKeyboardClickSound = async () => {
    if (!keyboardClickSoundFile) {
      showErrorToast('Please select a file first!');
      return;
    }

    setUploadingStates(prev => ({ ...prev, keyboardClickSound: true }));

    try {
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: keyboardClickSoundFile.name,
          fileType: keyboardClickSoundFile.type,
        },
      });

      const { url } = response.data;

      await axios.put(url, keyboardClickSoundFile, {
        headers: {
          'Content-Type': keyboardClickSoundFile.type,
        },
      });

      const fileUrl = url.split('?')[0];

      setSettings(prevSettings => ({
        ...prevSettings,
        keyboardClickSound: fileUrl,
        keyboardClickSoundFilename: keyboardClickSoundFile.name,
      }));

      showMsgSuccessToast('Keyboard click sound uploaded successfully!');
      setKeyboardClickSoundFile(null);
    } catch (error) {
      console.error('Upload failed:', error);
      showErrorToast('Upload failed. Please try again.');
    } finally {
      setUploadingStates(prev => ({ ...prev, keyboardClickSound: false }));
    }
  };

  const handleUploadPngBtn = async () => {
    if (!pngFile) {
      showErrorToast('Please select a PNG file first!');
      return;
    }

    setUploadingStates(prev => ({ ...prev, pngBtn: true }));

    try {
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: pngFile.name,
          fileType: pngFile.type,
        },
      });

      const { url } = response.data;

      await axios.put(url, pngFile, {
        headers: {
          'Content-Type': pngFile.type,
        },
      });

      const fileUrl = url.split('?')[0];

      setSettings(prevSettings => ({
        ...prevSettings,
        btnPng: fileUrl,
        btnPngFileName: pngFile.name,
      }));

      showMsgSuccessToast('PNG file uploaded successfully!');
      setPngFile(null);
    } catch (error) {
      console.error('Upload failed:', error);
      showErrorToast('Upload failed. Please try again.');
    } finally {
      setUploadingStates(prev => ({ ...prev, pngBtn: false }));
    }
  };

  const handleTogglePngBtnChange = async isOn => {
    const alertText =
      'Since PNG is enabled, only Height, Width, Margin Bottom, Font Family,Font color,Font Size and Background Image settings will be applied.';

    if (isOn) {
      Swal.fire({
        icon: 'info',
        title: 'Important Information',
        text: alertText,
        showCancelButton: false,
        confirmButtonText: 'Close',
        cancelButtonText: 'No, cancel',
        confirmButtonColor: buttonColor,
      }).then(result => {
        if (result.isConfirmed) {
          // Action if needed
        } else {
          console.log('Action canceled');
        }
      });
    }

    setSettings(prevSettings => ({
      ...prevSettings,
      pngBtnenabled: isOn,
    }));
  };

  const handleToggleHideBtnText = async isOn => {
    setSettings(prevSettings => ({
      ...prevSettings,
      hideBtnText: isOn,
    }));
  };

  const handleToggleIconChange = async isOn => {
    setSettings(prevSettings => ({
      ...prevSettings,
      enableIcon: isOn,
    }));
  };

  const handleUploadIcon = async () => {
    if (!iconFile) {
      showErrorToast('Please select an icon file first!');
      return;
    }

    setUploadingStates(prev => ({ ...prev, buttonIcon: true }));

    try {
      const response = await axios.get('/generate-signed-url', {
        params: {
          fileName: iconFile.name,
          fileType: iconFile.type,
        },
      });

      const { url } = response.data;

      await axios.put(url, iconFile, {
        headers: {
          'Content-Type': iconFile.type,
        },
      });

      const fileUrl = url.split('?')[0];

      setSettings(prevSettings => ({
        ...prevSettings,
        buttonIcon: fileUrl,
        buttonIconFileName: iconFile.name,
      }));

      showMsgSuccessToast('Icon uploaded successfully!');
      setIconFile(null);
    } catch (error) {
      console.error('Upload failed:', error);
      showErrorToast('Upload failed. Please try again.');
    } finally {
      setUploadingStates(prev => ({ ...prev, buttonIcon: false }));
    }
  };

  const createDropHandler = setMedia => acceptedFiles => {
    if (acceptedFiles.length > 0) {
      setMedia(acceptedFiles[0]);
    }
  };

  const getFileType = fileUrl => {
    if (!fileUrl) return 'blank';
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg'];
    const videoExtensions = ['.mp4', '.mov', '.avi', '.mkv', '.webm'];

    if (imageExtensions.some(ext => fileUrl.toLowerCase().endsWith(ext))) {
      return 'image';
    }
    if (videoExtensions.some(ext => fileUrl.toLowerCase().endsWith(ext))) {
      return 'video';
    }
    return 'other';
  };

  return (
    <div className=" ">
      <div>
        <div className="min-height-200px dashboard-container">
          <Box sx={{ width: '100%' }}>
            <Box sx={{ p: 3 }}>


              <form
                className="tab-wizard wizard-circle wizard vertical"
                onSubmit={handleSubmit}
              >
                <div style={{ marginBottom: '23px', textAlign: 'right' }}>
                  <ButtonMain text={'Sample Button'} settings={settings} />
                </div>

                <div
                  style={{
                    marginTop: '20px',
                    display: 'inline-flex',
                    gap: '26px',
                  }}
                >
                  <div className="setting form-group custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      checked={settings.pngBtnenabled || false}
                      onChange={e => handleTogglePngBtnChange(e.target.checked)}
                      id={`png-button-${userId}`}
                      className="custom-control-input"
                    />
                    <label className="custom-control-label" htmlFor={`png-button-${userId}`}>
                      Enable PNG Button
                    </label>
                  </div>
                  <div className="setting form-group custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      checked={settings.hideBtnText || false}
                      onChange={e => handleToggleHideBtnText(e.target.checked)}
                      id={`hide-text-${userId}`}
                      className="custom-control-input"
                    />
                    <label className="custom-control-label" htmlFor={`hide-text-${userId}`}>
                      Hide Button Text
                    </label>
                  </div>
                  <div className="setting form-group custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      checked={settings.enableIcon || false}
                      onChange={e => handleToggleIconChange(e.target.checked)}
                      id={`enable-icon-${userId}`}
                      className="custom-control-input"
                    />
                    <label className="custom-control-label" htmlFor={`enable-icon-${userId}`}>
                      Enable Icon
                    </label>
                  </div>
                </div>

                {/* Line Height, Padding, Margin Bottom */}
                <div className="row menu-card2">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Font Line Height:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.lineHeight ?? 1}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('lineHeight', Number(e.target.value))}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Padding:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.padding ?? 10}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('padding', Number(e.target.value))}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Margin Bottom:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.marginBottom ?? 5}
                        onChange={e => handleChange('marginBottom', Number(e.target.value))}
                      />
                    </div>
                  </div>
                </div>

                {/* Corner Radius, Height, Width */}
                <div className="row menu-card2">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Corner Radius:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.cornerRadius ?? 5}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('cornerRadius', Number(e.target.value))}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Height:</label>
                      <input
                        type="number"
                        value={settings.height ?? 50}
                        onChange={e => handleChange('height', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Width:</label>
                      <input
                        type="number"
                        value={settings.width ?? 150}
                        onChange={e => handleChange('width', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                {/* Outline */}
                <div className="row menu-card2">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '21px' }}>
                        Outline color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          checked={settings.outlineColor === 'transparent'}
                          disabled={settings.pngBtnenabled}
                          onChange={e =>
                            handleChange('outlineColor', e.target.checked ? 'transparent' : '#000000')
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.outlineColor === 'transparent' ? '' : settings.outlineColor}
                        onChange={newHex => handleChange('outlineColor', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.outlineColor === 'transparent' || settings.pngBtnenabled}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Outline Thickness:</label>
                      <input
                        type="number"
                        value={settings.outlineThickness ?? 1}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('outlineThickness', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Text Alignment:</label>
                      <select
                        id="textAlign"
                        value={settings.textAlign || 'center'}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('textAlign', e.target.value)}
                        className="form-select form-control"
                      >
                        <option value="left">Left</option>
                        <option value="center">Center</option>
                        <option value="right">Right</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Fill Color, Font Family, Font Color, Font Size */}
                <div className="row menu-card2">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '21px' }}>
                        Fill color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          checked={settings.fillColor === 'transparent' || settings.pngBtnenabled}
                          disabled={settings.pngBtnenabled}
                          onChange={e =>
                            handleChange('fillColor', e.target.checked ? 'transparent' : '#000000')
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.fillColor === 'transparent' ? '' : settings.fillColor}
                        onChange={newHex => handleChange('fillColor', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.fillColor === 'transparent' || settings.pngBtnenabled}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Font Family:</label>
                      <select
                        id="font"
                        value={settings.font || 'Arial'}
                        onChange={e => handleChange('font', e.target.value)}
                        className="form-select form-control"
                      >
                        {fontOptions}
                      </select>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '21px' }}>
                        Font color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          checked={settings.fontColor === 'transparent'}
                          onChange={e =>
                            handleChange('fontColor', e.target.checked ? 'transparent' : '#00000')
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.fontColor === 'transparent' ? '' : settings.fontColor}
                        onChange={newHex => handleChange('fontColor', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.fontColor === 'transparent'}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Font Size:</label>
                      <input
                        type="number"
                        value={settings.fontSize || 16}
                        onChange={e => handleChange('fontSize', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>

                {/* Shadow Settings */}
                <div className="row menu-card2">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Shadow angle:</label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.shadow?.angle ?? 125}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('shadow.angle', Number(e.target.value))}
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Shadow size:</label>
                      <input
                        type="number"
                        value={settings.shadow?.size ?? 10}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('shadow.size', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Shadow distance:</label>
                      <input
                        type="number"
                        value={settings.shadow?.distance ?? 15}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('shadow.distance', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Shadow Alpha:</label>
                      <input
                        type="number"
                        step="0.1"
                        min="0"
                        max="1"
                        value={settings.shadow?.alpha ?? 0.2}
                        disabled={settings.pngBtnenabled}
                        onChange={e => handleChange('shadow.alpha', Number(e.target.value))}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '25px' }}>
                        Shadow color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          checked={settings.shadow?.color === 'transparent'}
                          disabled={settings.pngBtnenabled}
                          onChange={e =>
                            handleChange('shadow.color', e.target.checked ? 'transparent' : '#000000')
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.shadow?.color === 'transparent' ? '' : settings.shadow?.color}
                        onChange={newHex => handleChange('shadow.color', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.shadow?.color === 'transparent' || settings.pngBtnenabled}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Highlight */}
                <div className="row menu-card2">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '21px' }}>
                        Highlight border color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          disabled={settings.pngBtnenabled}
                          checked={settings.highlight?.borderColor === 'transparent'}
                          onChange={e =>
                            handleChange(
                              'highlight.borderColor',
                              e.target.checked ? 'transparent' : '#00000'
                            )
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.highlight?.borderColor === 'transparent' ? '' : settings.highlight?.borderColor}
                        onChange={newHex => handleChange('highlight.borderColor', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.highlight?.borderColor === 'transparent' || settings.pngBtnenabled}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '21px' }}>
                        Highlight fill color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          disabled={settings.pngBtnenabled}
                          checked={settings.highlight?.fillColor === 'transparent'}
                          onChange={e =>
                            handleChange(
                              'highlight.fillColor',
                              e.target.checked ? 'transparent' : '#00000'
                            )
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.highlight?.fillColor === 'transparent' ? '' : settings.highlight?.fillColor}
                        onChange={newHex => handleChange('highlight.fillColor', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.highlight?.fillColor === 'transparent' || settings.pngBtnenabled}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="d-flex align-items-center" style={{ height: '25px' }}>
                        Highlight Font color: (Transparent
                        <input
                          type="checkbox"
                          className="ml-1 mr-1"
                          disabled={settings.pngBtnenabled}
                          checked={settings.highlight?.fontColor === 'transparent'}
                          onChange={e =>
                            handleChange(
                              'highlight.fontColor',
                              e.target.checked ? 'transparent' : '#00000'
                            )
                          }
                        />
                        )
                      </label>
                      <MuiColorInput
                        className="form-control mt-1"
                        format="hex"
                        value={settings.highlight?.fontColor === 'transparent' ? '' : settings.highlight?.fontColor}
                        onChange={newHex => handleChange('highlight.fontColor', newHex?.toUpperCase?.() || '#000000')}
                        fallbackValue="#000000"
                        disabled={settings.highlight?.fontColor === 'transparent' || settings.pngBtnenabled}
                        isAlphaHidden={true}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '0px !important',
                            height: 53,
                          },
                          '& .MuiOutlinedInput-input': {
                            height: '36px',
                          },
                          '& .MuiColorInput-Button': {
                            width: '49px !important',
                            height: '40px !important',
                          },
                          '& .MuiInputAdornment-root .MuiBox-root': {
                            width: 18,
                            height: 18,
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Click Sound */}
                <div className="row ">
                  <div className="col-md-6">
                    <div className={`form-group menu-card2 `}>
                      <label>Upload Click Sound:</label>
                      <MediaDropzone
                        onDrop={createDropHandler(setClickSoundFile)}
                        selectedFile={clickSoundFile}
                      />
                      <UploadButton
                        uploading={uploadingStates.clickSound}
                        onUpload={handleUploadClickSound}
                        buttonColor={buttonColor}
                      />
                      <div style={{ marginTop: '5px' }}>
                        Uploaded File:{' '}
                        <a
                          href={settings.clickSound}
                          style={{ fontWeight: 'bold' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {settings.clickSoundFilename || 'No sound file uploaded'}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Click sound volume <strong>(The volume range should be 0 to 1)</strong>:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.clickSoundVolume ?? 1}
                        min="0"
                        max="1"
                        step="0.1"
                        onChange={e => {
                          let value = Number(e.target.value);
                          if (value < 0) value = 0;
                          if (value > 1) value = 1;
                          handleChange('clickSoundVolume', value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Keyboard Click Sound */}
                <div className="row ">
                  <div className="col-md-6">
                    <div className={`form-group menu-card2 `}>
                      <label>Upload Keyboard Click Sound:</label>
                      <MediaDropzone
                        onDrop={createDropHandler(setKeyboardClickSoundFile)}
                        selectedFile={keyboardClickSoundFile}
                      />
                      <UploadButton
                        uploading={uploadingStates.keyboardClickSound}
                        onUpload={handleUploadKeyboardClickSound}
                        buttonColor={buttonColor}
                      />
                      <div style={{ marginTop: '5px' }}>
                        Uploaded File:{' '}
                        <a
                          href={settings.keyboardClickSound}
                          style={{ fontWeight: 'bold' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {settings.keyboardClickSoundFilename || 'No keyboard sound file uploaded'}
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Keyboard click sound volume <strong>(The volume range should be 0 to 1)</strong>:
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={settings.keyboardClickSoundVolume ?? 1}
                        min="0"
                        max="1"
                        step="0.1"
                        onChange={e => {
                          let value = Number(e.target.value);
                          if (value < 0) value = 0;
                          if (value > 1) value = 1;
                          handleChange('keyboardClickSoundVolume', value);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* PNG Button Upload */}
                <div className="row ">
                  <div className="col-md-6">
                    <div className={`form-group menu-card2 `}>
                      <label>Upload PNG Button Image:</label>
                      <MediaDropzone
                        onDrop={createDropHandler(setPngFile)}
                        selectedFile={pngFile}
                      />
                      <UploadButton
                        uploading={uploadingStates.pngBtn}
                        onUpload={handleUploadPngBtn}
                        buttonColor={buttonColor}
                      />
                      <div style={{ marginTop: '10px' }}>
                        {settings.btnPng ? (
                          <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ fontWeight: '600' }}>Uploaded File:</span>
                            <a
                              href={settings.btnPng}
                              style={{ fontWeight: 'bold' }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {settings.btnPngFileName}
                            </a>
                            {getFileType(settings.btnPng) === 'image' && (
                              <a href={settings.btnPng} target="_blank" rel="noreferrer">
                                <img src={settings.btnPng} style={{ maxWidth: '200px', maxHeight: '60px' }} alt="" />
                              </a>
                            )}
                          </div>
                        ) : (
                          <span>No PNG file uploaded</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Icon Upload Section */}
                {settings.enableIcon && (
                  <div className="row">
                    <div className="col-md-6">
                      <div className={`form-group menu-card2`}>
                        <label>Upload Button Icon:</label>

                        <MediaDropzone
                          onDrop={createDropHandler(setIconFile)}
                          selectedFile={iconFile}
                        />
                        <UploadButton
                          uploading={uploadingStates.buttonIcon}
                          onUpload={handleUploadIcon}
                          buttonColor={buttonColor}
                        />

                        <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div style={{ marginTop: "5px" }}>
                              Uploaded File:{" "}
                              <a
                                href={settings.buttonIcon}
                                style={{ fontWeight: "bold" }}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {settings.buttonIconFileName || 'No icon uploaded'}
                              </a>
                            </div>
                          </div>

                          <div
                            className="dimensions"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              gap: "15px",
                              height: "100%",
                            }}
                          >
                            {/* Size Input */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <label
                                style={{
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                  fontSize: "14px",
                                }}
                              >
                                Size (%):
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                value={settings.iconSize ?? 90}
                                min="0"
                                max="100"
                                onChange={(e) =>
                                  handleChange("iconSize", Number(e.target.value))
                                }
                                placeholder="Size"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className={`form-group menu-card2`}>
                        <label>Icon Position Settings:</label>
                        
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Icon Position:</label>
                              <select
                                value={settings.iconPosition || 'top'}
                                onChange={(e) => handleChange("iconPosition", e.target.value)}
                                className="form-select form-control"
                              >
                                <option value="left">Left</option>
                                <option value="top">Top (Center)</option>
                                <option value="right">Right</option>
                                <option value="bottom">Bottom (Center)</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label>Icon Spacing (px):</label>
                              <input
                                type="number"
                                className="form-control"
                                value={settings.iconSpacing ?? 8}
                                min="0"
                                max="50"
                                onChange={(e) =>
                                  handleChange("iconSpacing", Number(e.target.value))
                                }
                              />
                              <small style={{ color: "#666" }}>
                                Space between icon and text
                              </small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <button
                  style={{ backgroundColor: buttonColor, color: '#fff', marginTop: '20px' }}
                  type="submit"
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save Settings'}
                </button>
              </form>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

// MediaDropzone Component
const MediaDropzone = ({ onDrop, selectedFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'audio/*': ['.mp3', '.wav', '.ogg'],
      'image/*': ['.jpeg', '.jpg', '.png', '.gif'],
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #cccccc',
        padding: '40px',
        borderRadius: '5px',
        textAlign: 'center',
        cursor: 'pointer',
      }}
    >
      <input {...getInputProps()} />
      {selectedFile ? (
        <p>{selectedFile.name}</p>
      ) : (
        <p>Drag and drop a file here, or click to select a file</p>
      )}
    </div>
  );
};

// UploadButton Component
const UploadButton = ({ uploading, onUpload, buttonColor, ...props }) => (
  <button
    type="button"
    onClick={onUpload}
    style={{
      marginTop: '5px',
      backgroundColor: buttonColor,
      color: '#FFFFFF',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      padding: '10px 20px',
      ...props.style,
    }}
    disabled={uploading}
  >
    {uploading ? 'Uploading...' : 'Upload'}
  </button>
);

export default GlobalWayfinderButtonSettings;